module.exports = __webpack_public_path__ + "static/media/18.629e3a5c.jpg";